module.exports = __webpack_public_path__ + "img/cooperation8.28ded8d9.png";